import { links } from "../../links";
import BrandedPage from "../brandedPage";

import "./atkins-pricing.less";

import customerEnquiryFormTemplate from "../../templates/customerEnquiryForm.html";
import textInputEnquiryTemplate from "../../templates/horizontalForm/textInputEnquiry.html"
import compactSubmitButtonTemplate from "../../templates/horizontalForm/compactSubmitButton.html";
import selectEnquiryTemplate from "../../templates/horizontalForm/selectEnquiry.html";
import alertTemplate from "../../templates/alert.html";
import { EnquiryFormBindable } from "../../common/forms/enquiryFormBindable";

class Index extends BrandedPage {

    public readonly enquiryForm: EnquiryFormBindable = new EnquiryFormBindable();

    protected getTemplateHtmlSnippets(): string[] {
        let snippets : string[] = super.getTemplateHtmlSnippets();
        snippets.push(customerEnquiryFormTemplate, compactSubmitButtonTemplate, selectEnquiryTemplate, textInputEnquiryTemplate, alertTemplate);
        return snippets;
    }

    protected async loadContentAsync(): Promise<void> {
        await super.loadContentAsync();

        this.setActiveNav(BrandedPage.pricingNavPage);

        if (links.utilitySearchReportHash === location.hash) {
            $("#panel-utility-search-report").collapse('show');
        }
        else if (links.utilitySearchMapHash === location.hash) {
            $("#panel-utility-search-map").collapse('show');
        }
    }
}

(new Index()).initialiseAsync();